
<div class="dialog-component">
  <div class="cross">
    <button
      id="desktop-focus-gender"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"
      (click) ="dialogData.reset()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="mob-focus-gender"
        tabindex="0"
        type="button"
        class="close close-btn"
        aria-label="Close"
        (click) ="dialogData.reset()"
      ></button>
    </div>


    <div class="edit-gender-body">
      @if (dialogData.genderError) {
        <div
          role="alert"
          aria-label="error"
          class="page-error"
          >
          <label>Please select a valid gender</label>
        </div>
      }
      <label class="dob-label">What best describes your sex? </label>
      <div class="modal-genderbody-content edit-other-phone-modal">
        <form #myGenderForm="ngForm">
          <div role="radiogroup" aria-label="Gender">
            <div class="modal-form-group radio-wrapper">
              <input
                type="radio"
                tabindex="0"
                name="gender"
                [(ngModel)]="dialogData.selectedGender.gender"
                id="male"
                value="1"
                aria-label="Male"
                ngModel
                />
                <label for="male">Male</label>
              </div>
              <div class="modal-form-group radio-wrapper">
                <input
                  type="radio"
                  tabindex="0"
                  name="gender"
                  [(ngModel)]="dialogData.selectedGender.gender"
                  id="female"
                  value="2"
                  aria-label="Female"
                  ngModel
                  />
                  <label for="female">Female</label>
                </div>
                <div class="modal-form-group radio-wrapper">
                  <input
                    type="radio"
                    tabindex="0"
                    name="gender"
                    [(ngModel)]="dialogData.selectedGender.gender"
                    id="prefer-not-say"
                    value="3"
                    aria-label="Prefer not to say"
                    ngModel
                    />
                    <label for="prefer-not-say">Prefer not to say</label>
                  </div>
                </div>
                <div>
                  <div class="btn-container">
                    <button
                      role="button"
                      tabindex="0"
                      aria-label="save"
                      class="send-button"
                      [disabled]=""
                      (click)="dialogData.saveGenderDetails()"
                      >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>


        </div>
      </div>

